import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";
import styles from "./Login.module.css";
import Logo from "../../components/Logo";
import api from "../../services/api";
import { Form } from "react-bootstrap";
import Button from "../../components/Button";
import { toast } from "react-toastify";

export default function PasswordRecovery() {
  const hostUrl = window.location.host;
  const [loginID, setLoginID] = useState("");
  const [loginSucess, setloginSucess] = useState("");
  const [, setdisableButtons] = useState(false);
  const [formSucess, setformSucess] = useState(false);
  const [loading, setloading] = useState(false);

  async function forgotPassword(loginID) {
    const query = new URLSearchParams(window.location.search);
    const userType = query.get("t");
    let apiUrl = "";
    switch (userType) {
      case "g": //gestor
        apiUrl = "forgot-password";
        break;
      case "f": //formando
      default:
        apiUrl = "forgot-password-trainee";
        break;
    }
    setdisableButtons(true);
    try {
      const response = await api.post(apiUrl, {
        email: loginID,
        redirect_url: `http://${hostUrl}/password-change`,
      });
      setloginSucess(response.data.message);
      setformSucess(true);
    } catch (_err) {
      console.log("_err", _err);
      setloading(false);
      toast.error(
        _err?.response?.data[0]?.message ||
          _err?.response?.data?.error?.message ||
          "Aconteceu um Erro. Entre em contato com nossa equipe.",
      );
    }
  }

  function handleSubmit() {
    setloading(true);
    try {
      forgotPassword(loginID);
    } catch (_err) {
      setloading(false);
      console.log("_err", _err);
    }
  }

  return (
    <div className={`${styles.wrapLogin} ${styles._formando}`}>
      <div className="text-center">
        <Logo />
        <p className="mt-3">
          Enviaremos os dados de <b>Recuperação</b> para o seu email
        </p>
      </div>
      <Form>
        {!formSucess ? (
          <>
            <Form.Group className={`${styles.inputBox} lince-input`}>
              <p className="m-0">Email</p>
              <div className="lince-input__text">
                <Form.Control type="text" onChange={e => setLoginID(e.target.value)} name="loginID" value={loginID} />
              </div>
            </Form.Group>
            <Button
              color="primary"
              loading={loading}
              onClick={() => {
                handleSubmit();
              }}
              className="w-100 mt-4 p-4"
            >
              Recuperar Senha
            </Button>
          </>
        ) : (
          <p className={styles.formMsg}>
            <i className={styles.success_ico}>
              <FaCheck color="#8032A1" size={12} />
            </i>
            {loginSucess}
          </p>
        )}
      </Form>
    </div>
  );
}
